import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["aria-labelledby", "children", "inline", "name"];
import { Children, cloneElement } from 'react';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { filterProps } from '../../../utils/filterProps';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
const ToggleGroupWrapper = styled.div.withConfig({
  displayName: "ToggleGroup__ToggleGroupWrapper",
  componentId: "sc-1wf38lw-0"
})(({
  $cssStyles
}) => Object.assign({}, $cssStyles));

/**
 * Group clusters of Radio/Checkbox Buttons together, with common styling
 **/
export const ToggleGroup = props => {
  const {
      'aria-labelledby': ariaLabelledBy,
      children,
      inline,
      name
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  const {
    domProps: __domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  return /*#__PURE__*/_jsx(ToggleGroupWrapper, Object.assign({
    $cssStyles: cssStyles
  }, rest, {
    children: Children.map(children, child => {
      return child && child.type && /*#__PURE__*/cloneElement(child, Object.assign({
        inline,
        name,
        'aria-labelledby': `${ariaLabelledBy} ${child.props['aria-labelledby'] || ''}`.trim()
      }, child.props));
    })
  }));
};
ToggleGroup.displayName = 'ToggleGroup';